export enum FiltroUsuario {
  Todos = 0,
  Nome = 1,
  Login = 2,
  Por_PA = 3,
  Inativo = 4,
  Por_Nivel = 5
}
